import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CardsManagerService } from './cards-manager.service';
import { OverlayManagerService } from './overlay-manager.service';
import { BotidService } from '@shared-angular/services/ragai/botid.service';

export type DocSearchResult = {
  searchResults: {
    chunk?: {
      content: string;
    };
    document?: {
      filename: string;
    };
    documentUrl: string;
  }[];
}

@Injectable({
  providedIn: 'root'
})

export class DocSearchManagerService {

  public beforeItemHtml = `<div class="list-group me-3">`;
  public itemHtml = `
  <a class="list-group-item list-group-item-action docsearch-link" href="{{url}}">
    <i class="ri-file-pdf-2-fill"></i>
    <strong>{{filename}}</strong><br>
    <small>{{title}}</small>
  </a>
`;
  public afterItemHtml = `</div>`;

  constructor(private http: HttpClient, private botIdService: BotidService, private cards: CardsManagerService, private overlay: OverlayManagerService) { }

  public clickFn: (url: string) => void = (url: string) => {
    this.overlay.html("<iframe src=" + url + " class='docsearch-overlay-frame'></iframe>");
  };

  private _renderTemplate(template: string, data: Record<string, string>): string {
    return template.replace(/{{(.*?)}}/g, (_: string, key: string) => {
      return data[key.trim()] ?? "";
    });
  }

  public async searchAsJson(searchString: string, skillIds: null | string[] = null, searchCount: number = 5, minScore: number = 0, returnType: string = "json", searchType: string = "vector") {

    const data = await firstValueFrom(this.http.post(`/api/user/docsearch/${this.botIdService.getBotId()}/search`,
      {
        searchString,
        searchCount,
        minScore: minScore / 100,
        skillIds,
        searchType
      }
    )) as DocSearchResult;

    if (returnType === "hasresults") {
      return data.searchResults.length > 0;
    }
    if (returnType === "table") {
      return this.jsonToHtml(data);
    }
    if (returnType === "counter") {
      return data.searchResults.length;
    }
    if (returnType === "text") {
      return data.searchResults.map(r => `${r.document?.filename ?? "Unbekanntes Dokument"}: ${r.chunk?.content ?? "Kein Inhalt"}`).join("\n\n");
    }
    return data;
  }

  public jsonToHtml(data: DocSearchResult): string {
    let html = this.beforeItemHtml;
    data.searchResults.forEach(result => {
      html += this._renderTemplate(this.itemHtml, {
        title: result.chunk?.content ?? "Kein Titel",
        filename: result.document?.filename ?? "Unbekanntes Dokument",
        url: result.documentUrl
      });
    });
    html += this.afterItemHtml;
    return html;
  }

  public async searchAsCard(searchString: string, skillIds: null | string[], searchCount: number = 5, minScore: number = 0) {
    const data = (await this.searchAsJson(searchString, skillIds, searchCount, minScore)) as DocSearchResult;
    const html = this.jsonToHtml(data);
    await this.cards.html(html);
  }

  public async docSearchResult(searchString: string, skillIds: null | string[], searchCount: number = 5, minScore: number = 0) {
    const data = (await this.searchAsJson(searchString, skillIds, searchCount, minScore)) as DocSearchResult;
    const html = this.jsonToHtml(data);
    return html;
  }
}
